import { Offer } from "common/api/decimal/methods/compareAndPurchase";
import styles from "./OfferItem.module.scss";
import OfferAction from "./OfferAction";
import { usePurchaseOptionsLoaderData } from "./purchaseOptionsLoader";
import ItemCondition from "../common/ItemCondition";
import MaterialTags from "../common/MaterialTags";

export default function OfferItem({
  offer,
  isPrimaryAction = true,
}: {
  offer: Offer;
  isPrimaryAction?: boolean;
}) {
  const { cart } = usePurchaseOptionsLoaderData();
  const cartItems = cart?.bookItems;
  let itemIsInCart = false;
  let isbnIsInCart = false;
  if (cartItems) {
    itemIsInCart =
      cartItems.findIndex(({ itemId }) => {
        return itemId === offer.itemId;
      }) !== -1;
    isbnIsInCart =
      cartItems.findIndex(({ isbn }) => {
        return isbn === offer.isbn;
      }) !== -1;
  }
  const Price = () => <div className={styles.price}>{offer.fprice}</div>;

  return (
    <li className={styles.outerContainer}>
      <div className={styles.container}>
        <div className={styles.startContainer}>
          <div className={styles.header}>
            <div className={styles.formatContainer}>
              <MaterialTags format={offer.variant} />
              <ItemCondition item={offer} className={styles.details} />
            </div>
            <div className={styles.startPrice}>
              <Price />
            </div>
          </div>
          <h3 className={styles.retailer}>{offer.retailerName}</h3>
          <div className={styles.details}>{offer.comments}</div>
          <div className={styles.details}>{offer.description}</div>
        </div>
        <div className={styles.endContainer}>
          <div className={styles.endPrice}>
            <Price />
          </div>
          <OfferAction
            itemIsInCart={itemIsInCart}
            isbnIsInCart={isbnIsInCart}
            isPrimaryAction={isPrimaryAction}
            tempBookItemId={offer.tempBookItemId}
            price={offer.fprice}
            retailer={offer.retailerName}
          />
        </div>
      </div>
    </li>
  );
}
